import { SupportIsAlwaysAvailable } from './SupportIsAlwaysAvailable';
import { WhatYouCanExpect } from './WhatYouCanExpect';
import { FeaturesContainer } from './FeaturesContainer';
import { YourOwnNutritionist } from './YourOwnNutritionist';
import { DeliciousRecipes } from './DeliciousRecipes';
import { ArticlesSupportingTheScience } from './ArticlesSupportingTheScience';

export const WhatYouCanExpectSection = (): JSX.Element => (
  <section className="flex flex-col items-center bg-grey-400 md:px-[40px] lg:px-[60px]">
    <WhatYouCanExpect />
    <SupportIsAlwaysAvailable />
    <FeaturesContainer>
      <YourOwnNutritionist />
      <DeliciousRecipes />
      <ArticlesSupportingTheScience />
    </FeaturesContainer>
  </section>
);
